const kb = 1;
const mb = 1024 * kb;
const gb = 1024 * mb;

export const fileSize = {
  kbToGb: size => size / gb
};
